import {Handle403} from "../Utilities";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

class ApiClient {
  async getAccessToken() {
    let params = new URLSearchParams(document.location.search)
    if(params.has("aToken")){
      cookies.set('aToken', params.get("aToken"), { path: '/' });
    }
    return params.get("aToken") || cookies.get("aToken");
  }

  async fetchWithToken(url, options = {}) {
    const token = await this.getAccessToken();
    const headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, {
      ...options,
      headers,
    });

    if (!response.ok) {
      if(response.status === 403){
        Handle403()
      }
      throw new Error(`API request failed with status ${response.status}`);
    }

    const contentType = response.headers.get('Content-Type');
    if (contentType && contentType.includes('application/json')) {
      return response.json();
    }

    return response;
  }

  async get(url, options) {
    return this.fetchWithToken(url, options);
  }

  async post(url, data, options) {
    return this.fetchWithToken(url, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async put(url, data, options) {
    return this.fetchWithToken(url, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }
  async delete(url, options) {
    return this.fetchWithToken(url, {
      ...options,
      method: 'DELETE',
    });
  }

  async getDataTableAjaxSettings(url, options, dataSrc = ''){
    return {
      url: url,
      dataSrc: dataSrc,
      headers: {
        ...options,
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + await this.getAccessToken(),
      },
      error: function (xhr, error, code){
        if (xhr.status === 403){
          Handle403()
        }
      }
    }
  }
}

export const createApiClient = () => {
  return new ApiClient();
};
